import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=97cf86ea&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=97cf86ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cf86ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97cf86ea')) {
      api.createRecord('97cf86ea', component.options)
    } else {
      api.reload('97cf86ea', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=97cf86ea&scoped=true&", function () {
      api.rerender('97cf86ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l4ybcO0mv4Za/JS/comp/DateRange.vue"
export default component.exports